import { render } from "./ConversationsByMainTopic.vue?vue&type=template&id=ac92670c&scoped=true"
import script from "./ConversationsByMainTopic.vue?vue&type=script&lang=js"
export * from "./ConversationsByMainTopic.vue?vue&type=script&lang=js"

import "./ConversationsByMainTopic.vue?vue&type=style&index=0&id=ac92670c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac92670c"]])

export default __exports__